import { useState, useEffect, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  getCmsConfig, saveCmsConfig,
  getCmsBanners, createCmsBanner, updateCmsBanner, deleteCmsBanner,
  getCmsServicios, createCmsServicio, updateCmsServicio, deleteCmsServicio,
  getCmsProyectos, createCmsProyecto, updateCmsProyecto, deleteCmsProyecto,
  getCmsBlog, createCmsBlogPost, updateCmsBlogPost, deleteCmsBlogPost,
  getCmsEquipo, createCmsEquipoMember, updateCmsEquipoMember, deleteCmsEquipoMember,
  getCmsTestimonios, createCmsTestimonio, updateCmsTestimonio, deleteCmsTestimonio,
  getCmsProductos, createCmsProducto, updateCmsProducto, deleteCmsProducto,
  getProductos, getProductoPorId, getAlmacenes,
  getTiendaConfig, saveTiendaConfig, getTiendaCatalogo,
  getTiendaEnvios, createTiendaEnvio, updateTiendaEnvio, deleteTiendaEnvio,
  getPedidosWeb, accionPedidoWeb, subirFotoCms,
} from '../services/api';

const TABS = [
  { key: 'config',      label: 'Configuración' },
  { key: 'banners',     label: 'Banners' },
  { key: 'servicios',   label: 'Servicios' },
  { key: 'proyectos',   label: 'Proyectos' },
  { key: 'productos',   label: 'Tienda' },
  { key: 'ventas',      label: 'Ventas en línea' },
  { key: 'pedidos',     label: 'Pedidos web' },
  { key: 'blog',        label: 'Blog' },
  { key: 'equipo',      label: 'Equipo' },
  { key: 'testimonios', label: 'Testimonios' },
];

const s = {
  page:    { padding: '24px', maxWidth: 1100, margin: '0 auto' },
  header:  { marginBottom: 24 },
  h1:      { fontSize: 22, fontWeight: 700, color: '#e2e8f0', margin: 0 },
  sub:     { fontSize: 13, color: '#64748b', marginTop: 4 },
  tabs:    { display: 'flex', gap: 6, marginBottom: 24, borderBottom: '1px solid #1e293b', paddingBottom: 0, flexWrap: 'wrap' },
  tab:     { padding: '8px 16px', fontSize: 13, fontWeight: 500, cursor: 'pointer', border: 'none', background: 'none', color: '#64748b', borderBottom: '2px solid transparent', marginBottom: -1 },
  tabActive:{ padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', border: 'none', background: 'none', color: '#3b82f6', borderBottom: '2px solid #3b82f6', marginBottom: -1 },
  card:    { background: '#0f172a', border: '1px solid #1e293b', borderRadius: 10, padding: 20, marginBottom: 16 },
  row:     { display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 14 },
  field:   { display: 'flex', flexDirection: 'column', gap: 5, flex: 1, minWidth: 200 },
  label:   { fontSize: 12, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 0.5 },
  input:   { background: '#1e293b', border: '1px solid #334155', color: '#e2e8f0', borderRadius: 7, padding: '8px 12px', fontSize: 13, outline: 'none' },
  textarea:{ background: '#1e293b', border: '1px solid #334155', color: '#e2e8f0', borderRadius: 7, padding: '8px 12px', fontSize: 13, outline: 'none', resize: 'vertical', minHeight: 80 },
  btnPrimary: { background: '#2563eb', color: '#fff', border: 'none', borderRadius: 7, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer' },
  btnDanger:  { background: '#ef4444', color: '#fff', border: 'none', borderRadius: 7, padding: '6px 12px', fontSize: 12, cursor: 'pointer' },
  btnSecondary: { background: '#1e293b', color: '#e2e8f0', border: '1px solid #334155', borderRadius: 7, padding: '7px 14px', fontSize: 13, cursor: 'pointer' },
  btnSmall: { background: '#1e293b', color: '#94a3b8', border: '1px solid #334155', borderRadius: 6, padding: '5px 10px', fontSize: 12, cursor: 'pointer' },
  listItem: { background: '#0f172a', border: '1px solid #1e293b', borderRadius: 8, padding: '12px 16px', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 12 },
  listMain: { flex: 1 },
  listTitle:{ fontSize: 14, fontWeight: 600, color: '#e2e8f0' },
  listSub:  { fontSize: 12, color: '#64748b', marginTop: 2 },
  badge:    { fontSize: 11, padding: '2px 8px', borderRadius: 20, fontWeight: 600 },
  badgeGreen: { background: 'rgba(34,197,94,.15)', color: '#4ade80' },
  badgeGray:  { background: 'rgba(100,116,139,.15)', color: '#94a3b8' },
  addBtn: { display: 'flex', alignItems: 'center', gap: 6, background: '#1e293b', border: '1px dashed #334155', color: '#64748b', borderRadius: 8, padding: '10px 16px', fontSize: 13, cursor: 'pointer', width: '100%', justifyContent: 'center', marginTop: 8 },
  formPanel: { background: '#060f1e', border: '1px solid #1e293b', borderRadius: 10, padding: 20, marginTop: 16 },
  toggle:   { display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' },
  toggleLabel: { fontSize: 13, color: '#e2e8f0' },
};

function Toggle({ value, onChange }) {
  return (
    <div style={s.toggle} onClick={() => onChange(!value)}>
      <div style={{
        width: 40, height: 22, borderRadius: 11, background: value ? '#2563eb' : '#334155',
        position: 'relative', transition: 'background .2s',
      }}>
        <div style={{
          position: 'absolute', top: 3, left: value ? 21 : 3,
          width: 16, height: 16, borderRadius: 8, background: '#fff', transition: 'left .2s',
        }}/>
      </div>
      <span style={s.toggleLabel}>{value ? 'Activo' : 'Inactivo'}</span>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div style={s.field}>
      <label style={s.label}>{label}</label>
      {children}
    </div>
  );
}

// ── Pestaña: Configuración ──────────────────────────────────────────────────
function TabConfig() {
  const [form, setForm] = useState({
    nombre_sitio:'', descripcion:'', slogan:'', logo_url:'', primary_color:'#e65c00',
    secondary_color:'#0A1628', email:'', telefono:'', whatsapp:'', direccion:'', ciudad:'',
    meta_descripcion:'', meta_keywords:'',
  });
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    getCmsConfig().then(d => { if (d && d.nombre_sitio !== undefined) setForm(f => ({...f,...d})); }).catch(()=>{});
  }, []);

  const set = (k,v) => setForm(f => ({...f,[k]:v}));

  const save = async () => {
    setSaving(true);
    await saveCmsConfig(form).catch(()=>{});
    setSaving(false); setSaved(true); setTimeout(()=>setSaved(false),2000);
  };

  return (
    <div>
      <div style={s.card}>
        <div style={{marginBottom:16,fontSize:14,fontWeight:700,color:'#94a3b8'}}>Datos del sitio</div>
        <div style={s.row}>
          <Field label="Nombre del sitio"><input style={s.input} value={form.nombre_sitio} onChange={e=>set('nombre_sitio',e.target.value)} placeholder="Ej: ION Energy SAS"/></Field>
          <Field label="Slogan"><input style={s.input} value={form.slogan} onChange={e=>set('slogan',e.target.value)} placeholder="Energía que respalda tu mundo"/></Field>
        </div>
        <div style={s.row}>
          <Field label="Descripción del sitio">
            <textarea style={s.textarea} value={form.descripcion} onChange={e=>set('descripcion',e.target.value)} placeholder="Descripción corta para el Home y SEO"/>
          </Field>
        </div>
        <div style={s.row}>
          <Field label="URL del logo"><input style={s.input} value={form.logo_url} onChange={e=>set('logo_url',e.target.value)} placeholder="https://..."/></Field>
        </div>
        <div style={s.row}>
          <Field label="Color primario">
            <div style={{display:'flex',gap:8,alignItems:'center'}}>
              <input type="color" value={form.primary_color} onChange={e=>set('primary_color',e.target.value)} style={{width:40,height:32,border:'none',background:'none',cursor:'pointer'}}/>
              <input style={{...s.input,flex:1}} value={form.primary_color} onChange={e=>set('primary_color',e.target.value)}/>
            </div>
          </Field>
          <Field label="Color secundario">
            <div style={{display:'flex',gap:8,alignItems:'center'}}>
              <input type="color" value={form.secondary_color} onChange={e=>set('secondary_color',e.target.value)} style={{width:40,height:32,border:'none',background:'none',cursor:'pointer'}}/>
              <input style={{...s.input,flex:1}} value={form.secondary_color} onChange={e=>set('secondary_color',e.target.value)}/>
            </div>
          </Field>
        </div>
      </div>

      <div style={s.card}>
        <div style={{marginBottom:16,fontSize:14,fontWeight:700,color:'#94a3b8'}}>Contacto</div>
        <div style={s.row}>
          <Field label="Email"><input style={s.input} value={form.email} onChange={e=>set('email',e.target.value)} placeholder="info@ionenergy.com.co"/></Field>
          <Field label="Teléfono"><input style={s.input} value={form.telefono} onChange={e=>set('telefono',e.target.value)} placeholder="(601) 123 4567"/></Field>
          <Field label="WhatsApp"><input style={s.input} value={form.whatsapp} onChange={e=>set('whatsapp',e.target.value)} placeholder="+57 300 123 4567"/></Field>
        </div>
        <div style={s.row}>
          <Field label="Dirección"><input style={s.input} value={form.direccion} onChange={e=>set('direccion',e.target.value)} placeholder="Calle 100 #50-30"/></Field>
          <Field label="Ciudad"><input style={s.input} value={form.ciudad} onChange={e=>set('ciudad',e.target.value)} placeholder="Bogotá"/></Field>
        </div>
      </div>

      <div style={s.card}>
        <div style={{marginBottom:16,fontSize:14,fontWeight:700,color:'#94a3b8'}}>SEO</div>
        <div style={s.row}>
          <Field label="Meta descripción"><textarea style={s.textarea} value={form.meta_descripcion} onChange={e=>set('meta_descripcion',e.target.value)}/></Field>
        </div>
        <div style={s.row}>
          <Field label="Palabras clave (separadas por coma)"><input style={s.input} value={form.meta_keywords} onChange={e=>set('meta_keywords',e.target.value)}/></Field>
        </div>
      </div>

      <button style={s.btnPrimary} onClick={save} disabled={saving}>
        {saving ? 'Guardando...' : saved ? '✓ Guardado' : 'Guardar configuración'}
      </button>
    </div>
  );
}

// ── Generic CRUD list ──────────────────────────────────────────────────────
// Los renderForm usan hooks: se montan como componente propio para que React
// no los cuente como hooks de la lista (si no, falla al abrir «Editar»).
function FormHost({ render, init, onSave, onCancel }) {
  return render(init, onSave, onCancel);
}

function CrudSection({ items, onAdd, onEdit, onDelete, renderItem, renderForm, emptyLabel }) {
  const [editing, setEditing] = useState(null); // null | 'new' | {item}

  const handleSave = async (data) => {
    if (editing === 'new') await onAdd(data);
    else await onEdit(editing.id, data);
    setEditing(null);
  };

  return (
    <div>
      {items.map(item => (
        <div key={item.id} style={s.listItem}>
          <div style={s.listMain}>{renderItem(item)}</div>
          <span style={{...s.badge, ...(item.activo ? s.badgeGreen : s.badgeGray)}}>{item.activo ? 'Activo' : 'Inactivo'}</span>
          <button style={s.btnSmall} onClick={() => setEditing(editing?.id === item.id ? null : item)}>Editar</button>
          <button style={s.btnDanger} onClick={() => { if(window.confirm('¿Eliminar?')) onDelete(item.id); }}>Eliminar</button>
          {editing?.id === item.id && (
            <div style={{...s.formPanel, position:'absolute', left:0, right:0, zIndex:10}}><FormHost key={item.id} render={renderForm} init={editing} onSave={handleSave} onCancel={()=>setEditing(null)} /></div>
          )}
        </div>
      ))}
      {editing?.id === undefined && editing !== null && editing !== 'new' && null}

      {editing === 'new' && (
        <div style={s.formPanel}><FormHost key="nuevo" render={renderForm} init={{}} onSave={handleSave} onCancel={()=>setEditing(null)} /></div>
      )}

      <button style={s.addBtn} onClick={() => setEditing('new')}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
        {emptyLabel || 'Agregar nuevo'}
      </button>
    </div>
  );
}

// ── Pestaña: Banners ───────────────────────────────────────────────────────
function TabBanners() {
  const [items, setItems] = useState([]);
  const load = useCallback(() => getCmsBanners().then(setItems).catch(()=>{}), []);
  useEffect(() => { load(); }, [load]);

  const renderForm = (init, onSave, onCancel) => {
    const [f, setF] = useState({ titulo:'', subtitulo:'', descripcion:'', imagen_url:'', cta_texto:'', cta_url:'', orden:0, activo:true, ...init });
    const set = (k,v) => setF(p=>({...p,[k]:v}));
    return (
      <div>
        <div style={s.row}>
          <Field label="Título"><input style={s.input} value={f.titulo} onChange={e=>set('titulo',e.target.value)}/></Field>
          <Field label="Subtítulo"><input style={s.input} value={f.subtitulo} onChange={e=>set('subtitulo',e.target.value)}/></Field>
        </div>
        <div style={s.row}>
          <Field label="Descripción"><textarea style={s.textarea} value={f.descripcion} onChange={e=>set('descripcion',e.target.value)}/></Field>
        </div>
        <div style={s.row}>
          <Field label="URL imagen"><input style={s.input} value={f.imagen_url} onChange={e=>set('imagen_url',e.target.value)} placeholder="https://..."/></Field>
        </div>
        <div style={s.row}>
          <Field label="Texto CTA"><input style={s.input} value={f.cta_texto} onChange={e=>set('cta_texto',e.target.value)} placeholder="Solicitar Cotización"/></Field>
          <Field label="URL CTA"><input style={s.input} value={f.cta_url} onChange={e=>set('cta_url',e.target.value)}/></Field>
          <Field label="Orden"><input style={{...s.input,width:70}} type="number" value={f.orden} onChange={e=>set('orden',+e.target.value)}/></Field>
        </div>
        <div style={{display:'flex',gap:12,marginTop:8,alignItems:'center'}}>
          <Toggle value={f.activo} onChange={v=>set('activo',v)}/>
          <div style={{flex:1}}/>
          <button style={s.btnSecondary} onClick={onCancel}>Cancelar</button>
          <button style={s.btnPrimary} onClick={()=>onSave(f)}>Guardar</button>
        </div>
      </div>
    );
  };

  return (
    <CrudSection
      items={items}
      onAdd={async d=>{ await createCmsBanner(d); load(); }}
      onEdit={async (id,d)=>{ await updateCmsBanner(id,d); load(); }}
      onDelete={async id=>{ await deleteCmsBanner(id); load(); }}
      renderItem={item=>(
        <div>
          <div style={s.listTitle}>{item.titulo || '(sin título)'}</div>
          <div style={s.listSub}>{item.subtitulo || ''} {item.cta_texto && `· CTA: ${item.cta_texto}`}</div>
        </div>
      )}
      renderForm={renderForm}
      emptyLabel="Agregar banner"
    />
  );
}

// ── Pestaña: Servicios ─────────────────────────────────────────────────────
function TabServicios() {
  const [items, setItems] = useState([]);
  const load = useCallback(() => getCmsServicios().then(setItems).catch(()=>{}), []);
  useEffect(() => { load(); }, [load]);

  const renderForm = (init, onSave, onCancel) => {
    const [f, setF] = useState({ titulo:'', descripcion:'', descripcion_larga:'', icono:'', categoria:'', imagen_url:'', caracteristicas:[], orden:0, activo:true, ...init });
    const set = (k,v) => setF(p=>({...p,[k]:v}));
    return (
      <div>
        <div style={s.row}>
          <Field label="Título"><input style={s.input} value={f.titulo} onChange={e=>set('titulo',e.target.value)}/></Field>
          <Field label="Categoría"><input style={s.input} value={f.categoria} onChange={e=>set('categoria',e.target.value)} placeholder="UPS, Solar, Plantas..."/></Field>
          <Field label="Orden"><input style={{...s.input,width:70}} type="number" value={f.orden} onChange={e=>set('orden',+e.target.value)}/></Field>
        </div>
        <div style={s.row}>
          <Field label="Descripción corta"><textarea style={s.textarea} value={f.descripcion} onChange={e=>set('descripcion',e.target.value)}/></Field>
          <Field label="Descripción larga"><textarea style={s.textarea} value={f.descripcion_larga} onChange={e=>set('descripcion_larga',e.target.value)}/></Field>
        </div>
        <div style={s.row}>
          <Field label="Icono (URL)"><input style={s.input} value={f.icono} onChange={e=>set('icono',e.target.value)} placeholder="https://... (imagen o SVG)"/></Field>
          <Field label="Imagen (URL)"><input style={s.input} value={f.imagen_url} onChange={e=>set('imagen_url',e.target.value)}/></Field>
        </div>
        <div style={{display:'flex',gap:12,marginTop:8,alignItems:'center'}}>
          <Toggle value={f.activo} onChange={v=>set('activo',v)}/>
          <div style={{flex:1}}/>
          <button style={s.btnSecondary} onClick={onCancel}>Cancelar</button>
          <button style={s.btnPrimary} onClick={()=>onSave(f)}>Guardar</button>
        </div>
      </div>
    );
  };

  return (
    <CrudSection
      items={items}
      onAdd={async d=>{ await createCmsServicio(d); load(); }}
      onEdit={async (id,d)=>{ await updateCmsServicio(id,d); load(); }}
      onDelete={async id=>{ await deleteCmsServicio(id); load(); }}
      renderItem={item=>(
        <div>
          <div style={s.listTitle}>{item.titulo}</div>
          <div style={s.listSub}>{item.categoria && `${item.categoria} · `}{item.descripcion}</div>
        </div>
      )}
      renderForm={renderForm}
      emptyLabel="Agregar servicio"
    />
  );
}

// ── Pestaña: Proyectos ─────────────────────────────────────────────────────
function TabProyectos() {
  const [items, setItems] = useState([]);
  const load = useCallback(() => getCmsProyectos().then(setItems).catch(()=>{}), []);
  useEffect(() => { load(); }, [load]);

  const renderForm = (init, onSave, onCancel) => {
    const [f, setF] = useState({ titulo:'', slug:'', descripcion:'', categoria:'', imagen_url:'', cliente:'', anio:new Date().getFullYear(), tags:[], destacado:false, activo:true, ...init });
    const set = (k,v) => setF(p=>({...p,[k]:v}));
    return (
      <div>
        <div style={s.row}>
          <Field label="Título"><input style={s.input} value={f.titulo} onChange={e=>set('titulo',e.target.value)}/></Field>
          <Field label="Cliente"><input style={s.input} value={f.cliente} onChange={e=>set('cliente',e.target.value)}/></Field>
          <Field label="Año"><input style={{...s.input,width:90}} type="number" value={f.anio} onChange={e=>set('anio',+e.target.value)}/></Field>
        </div>
        <div style={s.row}>
          <Field label="Categoría"><input style={s.input} value={f.categoria} onChange={e=>set('categoria',e.target.value)} placeholder="Centro de Datos, Solar, Industrial..."/></Field>
          <Field label="Slug URL"><input style={s.input} value={f.slug} onChange={e=>set('slug',e.target.value)} placeholder="centro-datos-bogota"/></Field>
        </div>
        <div style={s.row}>
          <Field label="Descripción"><textarea style={s.textarea} value={f.descripcion} onChange={e=>set('descripcion',e.target.value)}/></Field>
        </div>
        <div style={s.row}>
          <Field label="Imagen (URL)"><input style={s.input} value={f.imagen_url} onChange={e=>set('imagen_url',e.target.value)}/></Field>
        </div>
        <div style={{display:'flex',gap:16,marginTop:8,alignItems:'center'}}>
          <Toggle value={f.activo} onChange={v=>set('activo',v)}/>
          <div style={s.toggle} onClick={()=>set('destacado',!f.destacado)}>
            <div style={{width:40,height:22,borderRadius:11,background:f.destacado?'#d97706':'#334155',position:'relative',transition:'background .2s'}}>
              <div style={{position:'absolute',top:3,left:f.destacado?21:3,width:16,height:16,borderRadius:8,background:'#fff',transition:'left .2s'}}/>
            </div>
            <span style={s.toggleLabel}>Destacado</span>
          </div>
          <div style={{flex:1}}/>
          <button style={s.btnSecondary} onClick={onCancel}>Cancelar</button>
          <button style={s.btnPrimary} onClick={()=>onSave(f)}>Guardar</button>
        </div>
      </div>
    );
  };

  return (
    <CrudSection
      items={items}
      onAdd={async d=>{ await createCmsProyecto(d); load(); }}
      onEdit={async (id,d)=>{ await updateCmsProyecto(id,d); load(); }}
      onDelete={async id=>{ await deleteCmsProyecto(id); load(); }}
      renderItem={item=>(
        <div>
          <div style={s.listTitle}>{item.titulo} {item.destacado && <span style={{...s.badge,...s.badgeGreen,marginLeft:6}}>Destacado</span>}</div>
          <div style={s.listSub}>{item.cliente} · {item.anio} · {item.categoria}</div>
        </div>
      )}
      renderForm={renderForm}
      emptyLabel="Agregar proyecto"
    />
  );
}

// ── Pestaña: Blog ──────────────────────────────────────────────────────────
function TabBlog() {
  const [items, setItems] = useState([]);
  const load = useCallback(() => getCmsBlog().then(setItems).catch(()=>{}), []);
  useEffect(() => { load(); }, [load]);

  const renderForm = (init, onSave, onCancel) => {
    const [f, setF] = useState({ titulo:'', slug:'', resumen:'', contenido:'', imagen_url:'', autor:'', categorias:[], publicado:false, publicado_en:'', ...init });
    const set = (k,v) => setF(p=>({...p,[k]:v}));
    return (
      <div>
        <div style={s.row}>
          <Field label="Título"><input style={s.input} value={f.titulo} onChange={e=>set('titulo',e.target.value)}/></Field>
          <Field label="Slug"><input style={s.input} value={f.slug} onChange={e=>set('slug',e.target.value)} placeholder="como-elegir-ups-para-empresa"/></Field>
        </div>
        <div style={s.row}>
          <Field label="Autor"><input style={s.input} value={f.autor} onChange={e=>set('autor',e.target.value)}/></Field>
          <Field label="Categorías (separadas por coma)"><input style={s.input} value={(f.categorias||[]).join(',')} onChange={e=>set('categorias',e.target.value.split(',').map(x=>x.trim()).filter(Boolean))}/></Field>
        </div>
        <div style={s.row}>
          <Field label="Resumen"><textarea style={s.textarea} value={f.resumen} onChange={e=>set('resumen',e.target.value)}/></Field>
        </div>
        <div style={s.row}>
          <Field label="Contenido (HTML o texto)"><textarea style={{...s.textarea,minHeight:160}} value={f.contenido} onChange={e=>set('contenido',e.target.value)}/></Field>
        </div>
        <div style={s.row}>
          <Field label="Imagen (URL)"><input style={s.input} value={f.imagen_url} onChange={e=>set('imagen_url',e.target.value)}/></Field>
          <Field label="Fecha publicación"><input type="date" style={s.input} value={f.publicado_en?.slice(0,10)||''} onChange={e=>set('publicado_en',e.target.value)}/></Field>
        </div>
        <div style={{display:'flex',gap:12,marginTop:8,alignItems:'center'}}>
          <Toggle value={f.publicado} onChange={v=>set('publicado',v)}/>
          <span style={{fontSize:13,color:'#64748b',marginLeft:4}}>{f.publicado ? 'Publicado' : 'Borrador'}</span>
          <div style={{flex:1}}/>
          <button style={s.btnSecondary} onClick={onCancel}>Cancelar</button>
          <button style={s.btnPrimary} onClick={()=>onSave(f)}>Guardar</button>
        </div>
      </div>
    );
  };

  return (
    <CrudSection
      items={items}
      onAdd={async d=>{ await createCmsBlogPost(d); load(); }}
      onEdit={async (id,d)=>{ await updateCmsBlogPost(id,d); load(); }}
      onDelete={async id=>{ await deleteCmsBlogPost(id); load(); }}
      renderItem={item=>(
        <div>
          <div style={s.listTitle}>{item.titulo}</div>
          <div style={s.listSub}>{item.autor && `${item.autor} · `}{(item.categorias||[]).join(', ')} {item.publicado_en && `· ${item.publicado_en?.slice(0,10)||''}`}</div>
        </div>
      )}
      renderForm={renderForm}
      emptyLabel="Crear artículo"
    />
  );
}

// ── Pestaña: Equipo ────────────────────────────────────────────────────────
function TabEquipo() {
  const [items, setItems] = useState([]);
  const load = useCallback(() => getCmsEquipo().then(setItems).catch(()=>{}), []);
  useEffect(() => { load(); }, [load]);

  const renderForm = (init, onSave, onCancel) => {
    const [f, setF] = useState({ nombre:'', cargo:'', foto_url:'', bio:'', linkedin_url:'', orden:0, activo:true, ...init });
    const set = (k,v) => setF(p=>({...p,[k]:v}));
    return (
      <div>
        <div style={s.row}>
          <Field label="Nombre"><input style={s.input} value={f.nombre} onChange={e=>set('nombre',e.target.value)}/></Field>
          <Field label="Cargo"><input style={s.input} value={f.cargo} onChange={e=>set('cargo',e.target.value)}/></Field>
          <Field label="Orden"><input style={{...s.input,width:70}} type="number" value={f.orden} onChange={e=>set('orden',+e.target.value)}/></Field>
        </div>
        <div style={s.row}>
          <Field label="Foto (URL)"><input style={s.input} value={f.foto_url} onChange={e=>set('foto_url',e.target.value)}/></Field>
          <Field label="LinkedIn (URL)"><input style={s.input} value={f.linkedin_url} onChange={e=>set('linkedin_url',e.target.value)}/></Field>
        </div>
        <div style={s.row}>
          <Field label="Biografía"><textarea style={s.textarea} value={f.bio} onChange={e=>set('bio',e.target.value)}/></Field>
        </div>
        <div style={{display:'flex',gap:12,marginTop:8,alignItems:'center'}}>
          <Toggle value={f.activo} onChange={v=>set('activo',v)}/>
          <div style={{flex:1}}/>
          <button style={s.btnSecondary} onClick={onCancel}>Cancelar</button>
          <button style={s.btnPrimary} onClick={()=>onSave(f)}>Guardar</button>
        </div>
      </div>
    );
  };

  return (
    <CrudSection
      items={items}
      onAdd={async d=>{ await createCmsEquipoMember(d); load(); }}
      onEdit={async (id,d)=>{ await updateCmsEquipoMember(id,d); load(); }}
      onDelete={async id=>{ await deleteCmsEquipoMember(id); load(); }}
      renderItem={item=>(
        <div>
          <div style={s.listTitle}>{item.nombre}</div>
          <div style={s.listSub}>{item.cargo}</div>
        </div>
      )}
      renderForm={renderForm}
      emptyLabel="Agregar persona"
    />
  );
}

// ── Pestaña: Productos (Tienda) ────────────────────────────────────────────
const CATEGORIAS_PROD = ['ups', 'baterias', 'plantas', 'solar', 'infraestructura'];
const DISPONIBILIDAD  = ['stock', 'pedido', 'agotado'];

function TabProductos() {
  const [items, setItems] = useState([]);
  const [filtCat, setFiltCat] = useState('');
  const load = useCallback(() => {
    getCmsProductos(filtCat ? { categoria: filtCat } : {}).then(setItems).catch(()=>{});
  }, [filtCat]);
  useEffect(() => { load(); }, [load]);

  const renderForm = (init, onSave, onCancel) => {
    const [f, setF] = useState({
      nombre:'', descripcion:'', descripcion_larga:'', categoria:'ups', marca:'', modelo:'',
      imagen_url:'', imagenes:[], specs:{}, precio:'Consultar', disponibilidad:'stock', condicion:'nuevo',
      badge:'', destacado:false, activo:true, orden:0, ...init,
      specs: typeof init.specs === 'string' ? JSON.parse(init.specs||'{}') : (init.specs||{}),
    });
    const set = (k,v) => setF(p=>({...p,[k]:v}));
    const [specsRaw, setSpecsRaw] = useState(JSON.stringify(f.specs, null, 2));

    return (
      <div>
        <div style={s.row}>
          <Field label="Nombre del producto">
            <input style={s.input} value={f.nombre} onChange={e=>set('nombre',e.target.value)} placeholder="Smart-UPS 1500VA LCD"/>
          </Field>
          <Field label="Marca">
            <input style={s.input} value={f.marca} onChange={e=>set('marca',e.target.value)} placeholder="APC, Eaton, Longi..."/>
          </Field>
          <Field label="Modelo">
            <input style={s.input} value={f.modelo} onChange={e=>set('modelo',e.target.value)} placeholder="SMT1500I"/>
          </Field>
        </div>
        <div style={s.row}>
          <Field label="Categoría">
            <select style={s.input} value={f.categoria} onChange={e=>set('categoria',e.target.value)}>
              {CATEGORIAS_PROD.map(c=><option key={c} value={c}>{c}</option>)}
            </select>
          </Field>
          <Field label="Disponibilidad">
            <select style={s.input} value={f.disponibilidad} onChange={e=>set('disponibilidad',e.target.value)}>
              {DISPONIBILIDAD.map(d=><option key={d} value={d}>{d}</option>)}
            </select>
          </Field>
          <Field label="Precio">
            <input style={s.input} value={f.precio} onChange={e=>set('precio',e.target.value)} placeholder="Consultar"/>
          </Field>
          <Field label="Badge">
            <input style={s.input} value={f.badge} onChange={e=>set('badge',e.target.value)} placeholder="Nuevo · Oferta · (vacío)"/>
          </Field>
          <Field label="Orden">
            <input style={{...s.input,width:70}} type="number" value={f.orden} onChange={e=>set('orden',+e.target.value)}/>
          </Field>
        </div>
        <DatosReacondicionado f={f} set={set} />
        <EnlaceInventario f={f} set={set} />
        <FotosProducto f={f} set={set} />
        <div style={s.row}>
          <Field label="Descripción corta">
            <textarea style={s.textarea} value={f.descripcion} onChange={e=>set('descripcion',e.target.value)} placeholder="1.500 VA / 1.000 W · Monofásico · Online"/>
          </Field>
          <Field label="Descripción larga">
            <textarea style={s.textarea} value={f.descripcion_larga} onChange={e=>set('descripcion_larga',e.target.value)}/>
          </Field>
        </div>
        <div style={s.row}>
          <Field label="URL imagen">
            <input style={s.input} value={f.imagen_url} onChange={e=>set('imagen_url',e.target.value)} placeholder="https://..."/>
          </Field>
        </div>
        <div style={s.row}>
          <Field label='Especificaciones técnicas (JSON) — ej: {"potencia":"1500VA","voltaje":"220V"}'>
            <textarea
              style={{...s.textarea, fontFamily:'monospace', fontSize:12}}
              value={specsRaw}
              onChange={e=>{
                setSpecsRaw(e.target.value);
                try { set('specs', JSON.parse(e.target.value)); } catch {}
              }}
            />
          </Field>
        </div>
        <div style={{display:'flex',gap:16,marginTop:8,alignItems:'center'}}>
          <Toggle value={f.activo} onChange={v=>set('activo',v)}/>
          <div style={s.toggle} onClick={()=>set('destacado',!f.destacado)}>
            <div style={{width:40,height:22,borderRadius:11,background:f.destacado?'#d97706':'#334155',position:'relative',transition:'background .2s'}}>
              <div style={{position:'absolute',top:3,left:f.destacado?21:3,width:16,height:16,borderRadius:8,background:'#fff',transition:'left .2s'}}/>
            </div>
            <span style={s.toggleLabel}>Destacado</span>
          </div>
          <div style={{flex:1}}/>
          <button style={s.btnSecondary} onClick={onCancel}>Cancelar</button>
          <button style={s.btnPrimary} onClick={()=>onSave(f)}>Guardar</button>
        </div>
      </div>
    );
  };

  const DISP_COLOR = { stock:'#4ade80', pedido:'#fb923c', agotado:'#f87171' };

  return (
    <div>
      {/* Filtro por categoría */}
      <div style={{display:'flex',gap:8,marginBottom:16,flexWrap:'wrap'}}>
        <button
          style={{...s.btnSmall, ...(filtCat==='' ? {background:'#2563eb',color:'#fff',borderColor:'#2563eb'} : {})}}
          onClick={()=>setFiltCat('')}
        >Todos</button>
        {CATEGORIAS_PROD.map(c=>(
          <button
            key={c}
            style={{...s.btnSmall, ...(filtCat===c ? {background:'#2563eb',color:'#fff',borderColor:'#2563eb'} : {})}}
            onClick={()=>setFiltCat(c)}
          >{c}</button>
        ))}
      </div>

      <CrudSection
        items={items}
        onAdd={async d=>{ await createCmsProducto(d); load(); }}
        onEdit={async (id,d)=>{ await updateCmsProducto(id,d); load(); }}
        onDelete={async id=>{ await deleteCmsProducto(id); load(); }}
        renderItem={item=>(
          <div style={{display:'flex',alignItems:'center',gap:12}}>
            {item.imagen_url && <img src={item.imagen_url} alt="" style={{width:44,height:44,objectFit:'contain',borderRadius:6,background:'#1e293b'}}/>}
            <div>
              <div style={s.listTitle}>
                {item.marca && <span style={{color:'#f97316',marginRight:6,fontSize:12,fontWeight:700}}>{item.marca.toUpperCase()}</span>}
                {item.nombre}
                {item.destacado && <span style={{...s.badge,...s.badgeGreen,marginLeft:8}}>★</span>}
              </div>
              <div style={s.listSub}>
                {item.categoria} · {item.descripcion}
                <span style={{marginLeft:8,fontWeight:600,color:DISP_COLOR[item.disponibilidad]||'#94a3b8'}}>● {item.disponibilidad}</span>
                <span style={{marginLeft:8,color:'#64748b'}}>{item.precio}</span>
                {item.vendible && <span style={{...s.badge,background:'rgba(59,130,246,.15)',color:'#60a5fa',marginLeft:8}}>Compra en línea</span>}
                {item.condicion === 'reacondicionado' && <span style={{...s.badge,background:'rgba(245,158,11,.15)',color:'#fbbf24',marginLeft:8}}>Reacondicionado{item.grado ? ' ' + item.grado : ''}</span>}
              </div>
            </div>
          </div>
        )}
        renderForm={renderForm}
        emptyLabel="Agregar producto"
      />
    </div>
  );
}

// ── Venta en línea: enlace con el inventario (precio e IVA) ────────────────
const pesos = (n) => '$' + Math.round(Number(n || 0)).toLocaleString('es-CO');
const conIva = (p) => Number(p.precio_unitario || 0) * (1 + Number(p.iva_pct || 0) / 100);

function EnlaceInventario({ f, set, campo = 'producto_id', titulo = 'Venta en línea', etiqueta = 'Producto del inventario (de aquí salen precio e IVA)', conVendible = true }) {
  const [q, setQ] = useState('');
  const [res, setRes] = useState([]);
  const [prod, setProd] = useState(null);
  const valor = f[campo];
  useEffect(() => {
    if (!valor || prod?.id === valor) return;
    getProductoPorId(valor).then(r => {
      const hit = (r.data || []).find(p => p.id === valor);
      if (hit) setProd(hit);
    }).catch(() => {});
  }, [valor]);
  useEffect(() => {
    if (q.trim().length < 2) { setRes([]); return; }
    const t = setTimeout(() => getProductos(q.trim()).then(r => setRes(r.data || [])).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [q]);
  const elegir = (p) => { set(campo, p.id); setProd(p); setQ(''); setRes([]); };
  return (
    <div style={{ ...s.card, background: '#0b1324' }}>
      <div style={{ fontSize: 13, fontWeight: 600, color: '#e2e8f0', marginBottom: 10 }}>{titulo}</div>
      <div style={s.row}>
        <Field label={etiqueta}>
          {valor ? (
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <div style={{ ...s.input, flex: 1 }}>
                {prod ? <><b>{prod.codigo}</b> · {prod.nombre} — {pesos(conIva(prod))} con IVA</> : 'Producto enlazado'}
                {prod?.tipo_producto === 'servicio' && <span style={{ color: '#f87171' }}> · es servicio: no se vende en línea</span>}
                {prod && !(Number(prod.precio_unitario) > 0) && <span style={{ color: '#f87171' }}> · sin precio en el inventario</span>}
              </div>
              <button style={s.btnSmall} onClick={() => { set(campo, null); if (conVendible) set('vendible', false); setProd(null); }}>Quitar</button>
            </div>
          ) : (
            <div style={{ position: 'relative' }}>
              <input style={{ ...s.input, width: '100%', boxSizing: 'border-box' }} value={q} onChange={e => setQ(e.target.value)} placeholder="Buscar por código o nombre…" />
              {res.length > 0 && (
                <div style={{ position: 'absolute', zIndex: 20, left: 0, right: 0, background: '#0f172a', border: '1px solid #334155', borderRadius: 7, maxHeight: 240, overflow: 'auto' }}>
                  {res.map(p => (
                    <div key={p.id} onClick={() => elegir(p)} style={{ padding: '8px 12px', cursor: 'pointer', fontSize: 13, color: '#e2e8f0', borderBottom: '1px solid #1e293b' }}>
                      <b>{p.codigo}</b> · {p.nombre} <span style={{ color: '#64748b' }}>— {pesos(conIva(p))}{p.tipo_producto === 'servicio' ? ' · servicio' : ''}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </Field>
        {conVendible && f.condicion !== 'reacondicionado' && <Field label="Días de entrega sin existencias">
          <input style={{ ...s.input, width: 120 }} type="number" min="1" value={f.dias_entrega_pedido || ''} onChange={e => set('dias_entrega_pedido', e.target.value ? +e.target.value : null)} placeholder="Por defecto" />
        </Field>}
      </div>
      {conVendible && <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{ ...s.toggle, opacity: f.producto_id ? 1 : 0.4 }} onClick={() => f.producto_id && set('vendible', !f.vendible)}>
          <div style={{ width: 40, height: 22, borderRadius: 11, background: f.vendible ? '#2563eb' : '#334155', position: 'relative' }}>
            <div style={{ position: 'absolute', top: 3, left: f.vendible ? 21 : 3, width: 16, height: 16, borderRadius: 8, background: '#fff' }} />
          </div>
          <span style={s.toggleLabel}>Se puede comprar en línea</span>
        </div>
        {!f.producto_id && <span style={{ fontSize: 12, color: '#64748b' }}>Enlace primero un producto del inventario.</span>}
      </div>}
    </div>
  );
}

// Reacondicionado: unidad única con grado, garantía, serial y baterías opcionales.
function DatosReacondicionado({ f, set }) {
  return (
    <div style={{ ...s.card, background: '#0b1324' }}>
      <div style={s.row}>
        <Field label="Condición">
          <select style={s.input} value={f.condicion || 'nuevo'} onChange={e => set('condicion', e.target.value)}>
            <option value="nuevo">Nuevo</option>
            <option value="reacondicionado">Reacondicionado</option>
          </select>
        </Field>
        {f.condicion === 'reacondicionado' && <>
          <Field label="Grado">
            <select style={s.input} value={f.grado || ''} onChange={e => set('grado', e.target.value || null)}>
              <option value="">—</option>
              <option value="A">A — como nuevo</option>
              <option value="B">B — detalles menores</option>
              <option value="C">C — uso visible</option>
            </select>
          </Field>
          <Field label="Garantía (meses)">
            <input style={{ ...s.input, width: 100 }} type="number" min="1" value={f.garantia_meses || ''} onChange={e => set('garantia_meses', e.target.value ? +e.target.value : null)} />
          </Field>
          <Field label="Serial">
            <input style={s.input} value={f.serial || ''} onChange={e => set('serial', e.target.value)} />
          </Field>
        </>}
      </div>
      {f.condicion === 'reacondicionado' && <>
        <p style={{ fontSize: 12, color: '#64748b', margin: '0 0 10px' }}>Se vende solo mientras haya existencia en la bodega de despacho (normalmente 1 unidad). Cualquier marca.</p>
        <EnlaceInventario f={f} set={set} campo="baterias_producto_id" titulo="Opción: baterías nuevas"
          etiqueta="Kit de baterías del inventario (su precio se suma si el cliente lo elige)" conVendible={false} />
      </>}
    </div>
  );
}

// Fotos subidas al servidor; la primera es la principal.
function FotosProducto({ f, set }) {
  const [subiendo, setSubiendo] = useState(false);
  const [err, setErr] = useState('');
  const fotos = [...new Set([f.imagen_url, ...(f.imagenes || [])].filter(Boolean))];
  const guardar = (lista) => { set('imagen_url', lista[0] || ''); set('imagenes', lista.slice(1)); };
  const subir = async (e) => {
    const archivos = [...e.target.files]; e.target.value = '';
    setSubiendo(true); setErr('');
    const nuevas = [];
    for (const a of archivos) {
      try { nuevas.push((await subirFotoCms(a)).url); } catch (x) { setErr(x.response?.data?.error || `No se pudo subir ${a.name}`); }
    }
    guardar([...fotos, ...nuevas]); setSubiendo(false);
  };
  return (
    <div style={s.row}>
      <Field label={`Fotos (${fotos.length}) — la primera es la principal`}>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
          {fotos.map((u, i) => (
            <div key={u} style={{ position: 'relative' }}>
              <img src={u} alt="" style={{ width: 64, height: 64, objectFit: 'cover', borderRadius: 6, border: i === 0 ? '2px solid #3b82f6' : '1px solid #334155', cursor: 'pointer' }}
                title={i === 0 ? 'Principal' : 'Hacer principal'} onClick={() => guardar([u, ...fotos.filter(x => x !== u)])} />
              <button style={{ position: 'absolute', top: -6, right: -6, ...s.btnDanger, padding: '0 6px', fontSize: 11 }} onClick={() => guardar(fotos.filter(x => x !== u))}>×</button>
            </div>
          ))}
          <label style={{ ...s.btnSmall, display: 'inline-block' }}>
            {subiendo ? 'Subiendo…' : 'Subir fotos'}
            <input type="file" accept="image/jpeg,image/png,image/webp" multiple style={{ display: 'none' }} onChange={subir} disabled={subiendo} />
          </label>
        </div>
        {err && <span style={{ fontSize: 12, color: '#f87171' }}>{err}</span>}
      </Field>
    </div>
  );
}

// ── Pestaña: Ventas en línea (configuración, envíos, qué se ve) ────────────
const DEPARTAMENTOS = ['Amazonas','Antioquia','Arauca','Atlántico','Bogotá D.C.','Bolívar','Boyacá','Caldas','Caquetá','Casanare','Cauca','Cesar','Chocó','Córdoba','Cundinamarca','Guainía','Guaviare','Huila','La Guajira','Magdalena','Meta','Nariño','Norte de Santander','Putumayo','Quindío','Risaralda','San Andrés','Santander','Sucre','Tolima','Valle del Cauca','Vaupés','Vichada'];
const lista = (txt) => String(txt || '').split(',').map(x => x.trim()).filter(Boolean);

function TabVentas() {
  const [cfg, setCfg] = useState(null);
  const [almacenes, setAlmacenes] = useState([]);
  const [envios, setEnvios] = useState([]);
  const [cat, setCat] = useState([]);
  const [msg, setMsg] = useState('');
  const [clave, setClave] = useState('');
  const [secreto, setSecreto] = useState('');
  const cargar = useCallback(() => {
    getTiendaConfig().then(setCfg).catch(e => setMsg(e.response?.data?.error || e.message));
    getTiendaEnvios().then(setEnvios).catch(() => {});
    getTiendaCatalogo().then(setCat).catch(() => {});
    getAlmacenes().then(r => setAlmacenes(r.data || [])).catch(() => {});
  }, []);
  useEffect(() => { cargar(); }, [cargar]);
  if (!cfg) return <div style={s.card}>{msg || 'Cargando…'}</div>;
  const set = (k, v) => setCfg(c => ({ ...c, [k]: v }));

  const guardar = async () => {
    setMsg('');
    try {
      const r = await saveTiendaConfig({ ...cfg, snelpay_clave: clave || undefined, snelpay_secreto: secreto || undefined });
      setCfg(r); setClave(''); setSecreto(''); setMsg('Guardado'); getTiendaCatalogo().then(setCat).catch(() => {});
    } catch (e) { setMsg(e.response?.data?.error || e.message); }
  };

  const comprables = cat.filter(c => c.comprable);
  return (
    <div>
      <div style={s.card}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
          <Toggle value={cfg.activa} onChange={v => set('activa', v)} />
          <span style={{ fontSize: 14, fontWeight: 600, color: cfg.activa ? '#4ade80' : '#94a3b8' }}>
            {cfg.activa ? 'La tienda está recibiendo pedidos' : 'Tienda apagada: el sitio solo muestra «Cotizar»'}
          </span>
        </div>
        <div style={s.row}>
          <Field label="Marcas que se venden (separadas por coma)">
            <input style={s.input} value={(cfg.marcas || []).join(', ')} onChange={e => set('marcas', lista(e.target.value))} placeholder="Schneider, APC, Powest" />
          </Field>
          <Field label="Categorías que se venden">
            <input style={s.input} value={(cfg.categorias || []).join(', ')} onChange={e => set('categorias', lista(e.target.value))} placeholder="ups, baterias" />
          </Field>
        </div>
        <div style={s.row}>
          <Field label="Factura al confirmarse el pago">
            <select style={s.input} value={cfg.facturacion} onChange={e => set('facturacion', e.target.value)}>
              <option value="automatica">Emitir a la DIAN automáticamente</option>
              <option value="borrador">Dejar en borrador para revisar</option>
              <option value="no">No facturar desde el pedido</option>
            </select>
          </Field>
          <Field label="Bodega de despacho (descuenta existencias)">
            <select style={s.input} value={cfg.almacen_id || ''} onChange={e => set('almacen_id', e.target.value || null)}>
              <option value="">— No descontar inventario —</option>
              {almacenes.map(a => <option key={a.id} value={a.id}>{a.nombre}</option>)}
            </select>
          </Field>
          <Field label="Días de entrega «por pedido»">
            <input style={{ ...s.input, width: 100 }} type="number" min="1" value={cfg.dias_entrega_pedido || ''} onChange={e => set('dias_entrega_pedido', +e.target.value)} />
          </Field>
        </div>
        <div style={s.row}>
          <Field label="Correo que recibe los pedidos">
            <input style={s.input} value={cfg.correo_avisos || ''} onChange={e => set('correo_avisos', e.target.value)} placeholder="ventas@empresa.com" />
          </Field>
          <Field label="Página de la tienda (a dónde vuelve el cliente al pagar)">
            <input style={s.input} value={cfg.url_tienda || ''} onChange={e => set('url_tienda', e.target.value)} placeholder="https://ionenergy.com.co/tienda" />
          </Field>
        </div>
      </div>

      <div style={s.card}>
        <div style={{ fontSize: 14, fontWeight: 600, color: '#e2e8f0', marginBottom: 6 }}>Cobro con SnelPay (QR Bre-B)</div>
        <p style={{ fontSize: 12, color: '#64748b', marginTop: 0 }}>
          El dinero llega directo a la cuenta de la empresa. En SnelPay, el aviso del comercio debe apuntar a:<br />
          <code style={{ color: '#93c5fd' }}>{cfg.url_aviso_snelpay}</code>
        </p>
        <div style={s.row}>
          <Field label={`Clave de API ${cfg.tiene_clave_snelpay ? '(guardada — escriba para cambiarla)' : ''}`}>
            <input style={s.input} type="password" autoComplete="off" value={clave} onChange={e => setClave(e.target.value)} placeholder="snp_…" />
          </Field>
          <Field label={`Secreto de avisos ${cfg.tiene_secreto_snelpay ? '(guardado — escriba para cambiarlo)' : ''}`}>
            <input style={s.input} type="password" autoComplete="off" value={secreto} onChange={e => setSecreto(e.target.value)} placeholder="whsec_…" />
          </Field>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 24 }}>
        <button style={s.btnPrimary} onClick={guardar}>Guardar configuración</button>
        {msg && <span style={{ fontSize: 13, color: msg === 'Guardado' ? '#4ade80' : '#f87171' }}>{msg}</span>}
      </div>

      <EnviosZonas envios={envios} recargar={() => getTiendaEnvios().then(setEnvios)} />

      <div style={s.card}>
        <div style={{ fontSize: 14, fontWeight: 600, color: '#e2e8f0', marginBottom: 4 }}>Qué se puede comprar ({comprables.length} de {cat.length})</div>
        <p style={{ fontSize: 12, color: '#64748b', marginTop: 0 }}>Para vender un producto: en «Tienda», enlácelo al inventario y active «Se puede comprar en línea».</p>
        {cat.map(c => (
          <div key={c.id} style={{ display: 'flex', gap: 10, padding: '6px 0', borderBottom: '1px solid #1e293b', fontSize: 13 }}>
            <span style={{ width: 8, height: 8, borderRadius: 4, marginTop: 6, background: c.comprable ? '#4ade80' : '#475569' }} />
            <span style={{ flex: 1, color: '#e2e8f0' }}>{c.marca ? <b>{c.marca} </b> : null}{c.nombre}</span>
            <span style={{ color: c.comprable ? '#e2e8f0' : '#64748b' }}>{c.comprable ? pesos(c.precio_publico) : c.motivo}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function EnviosZonas({ envios, recargar }) {
  const vacio = { zona: '', departamentos: [], ciudades: [], costo: 0, gratis_desde: '', dias: '', activo: true };
  const [ed, setEd] = useState(null);
  const guardar = async () => {
    if (ed.id) await updateTiendaEnvio(ed.id, ed); else await createTiendaEnvio(ed);
    setEd(null); recargar();
  };
  return (
    <div style={s.card}>
      <div style={{ fontSize: 14, fontWeight: 600, color: '#e2e8f0', marginBottom: 4 }}>Envío por zona</div>
      <p style={{ fontSize: 12, color: '#64748b', marginTop: 0 }}>Gana la zona más específica: ciudad, luego departamento, luego la zona sin ninguno («resto del país»). Sin zona que aplique, el sitio no deja comprar.</p>
      {envios.map(z => (
        <div key={z.id} style={s.listItem}>
          <div style={s.listMain}>
            <div style={s.listTitle}>{z.zona} — {Number(z.costo) ? pesos(z.costo) : 'Gratis'}{z.gratis_desde ? ` · gratis desde ${pesos(z.gratis_desde)}` : ''}</div>
            <div style={s.listSub}>{[...(z.ciudades || []), ...(z.departamentos || [])].join(', ') || 'Resto del país'}{z.dias ? ` · ${z.dias}` : ''}</div>
          </div>
          <button style={s.btnSmall} onClick={() => setEd({ ...z })}>Editar</button>
          <button style={s.btnDanger} onClick={async () => { if (window.confirm('¿Eliminar la zona?')) { await deleteTiendaEnvio(z.id); recargar(); } }}>Eliminar</button>
        </div>
      ))}
      {ed ? (
        <div style={s.formPanel}>
          <div style={s.row}>
            <Field label="Nombre de la zona"><input style={s.input} value={ed.zona} onChange={e => setEd({ ...ed, zona: e.target.value })} placeholder="Bogotá, Antioquia, Resto del país…" /></Field>
            <Field label="Costo (con IVA)"><input style={s.input} type="number" min="0" value={ed.costo} onChange={e => setEd({ ...ed, costo: e.target.value })} /></Field>
            <Field label="Gratis desde (opcional)"><input style={s.input} type="number" min="0" value={ed.gratis_desde ?? ''} onChange={e => setEd({ ...ed, gratis_desde: e.target.value })} /></Field>
            <Field label="Tiempo de entrega"><input style={s.input} value={ed.dias || ''} onChange={e => setEd({ ...ed, dias: e.target.value })} placeholder="1 a 2 días hábiles" /></Field>
          </div>
          <div style={s.row}>
            <Field label="Ciudades (separadas por coma)"><input style={s.input} value={(ed.ciudades || []).join(', ')} onChange={e => setEd({ ...ed, ciudades: lista(e.target.value) })} placeholder="Bogotá, Soacha" /></Field>
            <Field label="Departamentos">
              <select multiple style={{ ...s.input, height: 110 }} value={ed.departamentos || []}
                onChange={e => setEd({ ...ed, departamentos: [...e.target.selectedOptions].map(o => o.value) })}>
                {DEPARTAMENTOS.map(d => <option key={d} value={d}>{d}</option>)}
              </select>
            </Field>
          </div>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button style={s.btnSecondary} onClick={() => setEd(null)}>Cancelar</button>
            <button style={s.btnPrimary} onClick={guardar}>Guardar zona</button>
          </div>
        </div>
      ) : (
        <button style={s.addBtn} onClick={() => setEd({ ...vacio })}>Agregar zona de envío</button>
      )}
    </div>
  );
}

// ── Pestaña: Pedidos web ───────────────────────────────────────────────────
const ESTADO_PEDIDO = {
  pendiente_pago: ['Esperando pago', '#fbbf24'],
  pagado:         ['Pagado', '#60a5fa'],
  facturado:      ['Facturado', '#4ade80'],
  despachado:     ['Despachado', '#a78bfa'],
  cancelado:      ['Cancelado', '#94a3b8'],
  expirado:       ['Venció sin pago', '#94a3b8'],
};

function TabPedidos() {
  const [items, setItems] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [abierto, setAbierto] = useState(null);
  const [ocupado, setOcupado] = useState(null);
  const [msg, setMsg] = useState('');
  const cargar = useCallback(() => getPedidosWeb(filtro ? { estado: filtro } : {}).then(setItems).catch(e => setMsg(e.response?.data?.error || e.message)), [filtro]);
  useEffect(() => { cargar(); const t = setInterval(cargar, 20000); return () => clearInterval(t); }, [cargar]);

  const accion = async (p, a, confirmar, body) => {
    if (confirmar && !window.confirm(confirmar)) return;
    setOcupado(p.id); setMsg('');
    try { await accionPedidoWeb(p.id, a, body); await cargar(); }
    catch (e) { setMsg(`${p.numero}: ${e.response?.data?.error || e.message}`); }
    setOcupado(null);
  };

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        {[['', 'Todos'], ...Object.entries(ESTADO_PEDIDO).map(([k, v]) => [k, v[0]])].map(([k, l]) => (
          <button key={k || 'todos'} style={{ ...s.btnSmall, ...(filtro === k ? { background: '#2563eb', color: '#fff', borderColor: '#2563eb' } : {}) }} onClick={() => setFiltro(k)}>{l}</button>
        ))}
      </div>
      {msg && <div style={{ ...s.card, color: '#f87171', fontSize: 13 }}>{msg}</div>}
      {!items.length && <div style={{ ...s.card, color: '#64748b', fontSize: 13 }}>Aún no hay pedidos{filtro ? ' en este estado' : ''}.</div>}
      {items.map(p => {
        const [txt, color] = ESTADO_PEDIDO[p.estado] || [p.estado, '#94a3b8'];
        const c = p.comprador || {};
        const abiertoEste = abierto === p.id;
        return (
          <div key={p.id} style={{ ...s.card, padding: 14 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer' }} onClick={() => setAbierto(abiertoEste ? null : p.id)}>
              <div style={{ flex: 1 }}>
                <div style={s.listTitle}>{p.numero} · {c.nombre} <span style={{ color: '#64748b', fontWeight: 400 }}>— {pesos(p.total)}</span></div>
                <div style={s.listSub}>
                  {new Date(p.created_at).toLocaleString('es-CO', { timeZone: 'America/Bogota' })} · {c.ciudad} · {(p.items || []).map(i => `${i.cantidad}× ${i.nombre}`).join(', ')}
                  {p.factura_numero && <> · Factura {p.factura_numero}{p.factura_estado === 'borrador' ? ' (borrador)' : ''}</>}
                </div>
              </div>
              <span style={{ ...s.badge, background: color + '22', color }}>{txt}</span>
            </div>
            {p.error && <div style={{ marginTop: 8, fontSize: 12, color: '#f87171' }}>Atención: {p.error}</div>}
            {abiertoEste && (
              <div style={{ marginTop: 12, borderTop: '1px solid #1e293b', paddingTop: 12, fontSize: 13, color: '#cbd5e1' }}>
                <div>{c.tipo_documento} {c.documento}{c.dv ? '-' + c.dv : ''} · {c.email} · {c.telefono}</div>
                <div>{c.direccion}, {c.ciudad} ({c.departamento}) · Envío {p.envio_zona}: {pesos(p.envio)}</div>
                {c.notas && <div>Notas: {c.notas}</div>}
                {(p.items || []).map((i, k) => <div key={k}>· {i.cantidad} × {i.nombre} — {pesos(i.total)}{i.por_pedido ? ' (por pedido)' : ''}</div>)}
                {Array.isArray(p.proceso?.inventario) && <div style={{ color: '#fbbf24' }}>Inventario: {p.proceso.inventario.join(' · ')}</div>}
                {p.confirmado_por && <div>Pago confirmado {p.confirmado_por === 'manual' ? 'a mano' : 'por el banco'}{p.pagado_en ? ' el ' + new Date(p.pagado_en).toLocaleString('es-CO', { timeZone: 'America/Bogota' }) : ''}</div>}
                <div style={{ display: 'flex', gap: 8, marginTop: 12, flexWrap: 'wrap' }}>
                  {p.estado === 'pendiente_pago' && <>
                    <button style={s.btnPrimary} disabled={ocupado === p.id} onClick={() => accion(p, 'confirmar', `¿Ya vio en el banco el pago de ${pesos(p.total)} del pedido ${p.numero}? Se facturará y se descontará el inventario.`)}>Ya recibí el pago</button>
                    <button style={s.btnSecondary} disabled={ocupado === p.id} onClick={() => accion(p, 'cancelar', `¿Cancelar el pedido ${p.numero}?`)}>Cancelar</button>
                  </>}
                  {p.estado === 'pagado' && p.factura_estado === 'borrador' && <button style={s.btnPrimary} disabled={ocupado === p.id} onClick={() => accion(p, 'procesar', `¿Emitir la factura de ${p.numero} a la DIAN?`, { emitir: true })}>Emitir factura</button>}
                  {['pagado', 'facturado'].includes(p.estado) && p.error && <button style={s.btnSecondary} disabled={ocupado === p.id} onClick={() => accion(p, 'procesar')}>Reintentar</button>}
                  {['pagado', 'facturado'].includes(p.estado) && <button style={s.btnSecondary} disabled={ocupado === p.id} onClick={() => accion(p, 'despachar', null, { guia: window.prompt('Número de guía (opcional)') || null })}>Marcar despachado</button>}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

// ── Pestaña: Testimonios ───────────────────────────────────────────────────
function TabTestimonios() {
  const [items, setItems] = useState([]);
  const load = useCallback(() => getCmsTestimonios().then(setItems).catch(()=>{}), []);
  useEffect(() => { load(); }, [load]);

  const renderForm = (init, onSave, onCancel) => {
    const [f, setF] = useState({ nombre:'', empresa:'', cargo:'', texto:'', foto_url:'', calificacion:5, activo:true, ...init });
    const set = (k,v) => setF(p=>({...p,[k]:v}));
    return (
      <div>
        <div style={s.row}>
          <Field label="Nombre"><input style={s.input} value={f.nombre} onChange={e=>set('nombre',e.target.value)}/></Field>
          <Field label="Empresa"><input style={s.input} value={f.empresa} onChange={e=>set('empresa',e.target.value)}/></Field>
          <Field label="Cargo"><input style={s.input} value={f.cargo} onChange={e=>set('cargo',e.target.value)}/></Field>
        </div>
        <div style={s.row}>
          <Field label="Testimonio"><textarea style={s.textarea} value={f.texto} onChange={e=>set('texto',e.target.value)}/></Field>
        </div>
        <div style={s.row}>
          <Field label="Foto (URL)"><input style={s.input} value={f.foto_url} onChange={e=>set('foto_url',e.target.value)}/></Field>
          <Field label="Calificación (1-5)"><input style={{...s.input,width:80}} type="number" min={1} max={5} value={f.calificacion} onChange={e=>set('calificacion',+e.target.value)}/></Field>
        </div>
        <div style={{display:'flex',gap:12,marginTop:8,alignItems:'center'}}>
          <Toggle value={f.activo} onChange={v=>set('activo',v)}/>
          <div style={{flex:1}}/>
          <button style={s.btnSecondary} onClick={onCancel}>Cancelar</button>
          <button style={s.btnPrimary} onClick={()=>onSave(f)}>Guardar</button>
        </div>
      </div>
    );
  };

  return (
    <CrudSection
      items={items}
      onAdd={async d=>{ await createCmsTestimonio(d); load(); }}
      onEdit={async (id,d)=>{ await updateCmsTestimonio(id,d); load(); }}
      onDelete={async id=>{ await deleteCmsTestimonio(id); load(); }}
      renderItem={item=>(
        <div>
          <div style={s.listTitle}>{item.nombre} · {'★'.repeat(item.calificacion||5)}</div>
          <div style={s.listSub}>{item.cargo && `${item.cargo}, `}{item.empresa}</div>
        </div>
      )}
      renderForm={renderForm}
      emptyLabel="Agregar testimonio"
    />
  );
}

const TAB_COMPONENTS = {
  config:      TabConfig,
  banners:     TabBanners,
  servicios:   TabServicios,
  proyectos:   TabProyectos,
  productos:   TabProductos,
  ventas:      TabVentas,
  pedidos:     TabPedidos,
  blog:        TabBlog,
  equipo:      TabEquipo,
  testimonios: TabTestimonios,
};

export default function CmsWeb() {
  const [sp] = useSearchParams();
  const activeTab = TABS.some(t => t.key === sp.get('tab')) ? sp.get('tab') : 'config';
  const TabContent = TAB_COMPONENTS[activeTab] || TAB_COMPONENTS.config;
  const label = TABS.find(t => t.key === activeTab)?.label || '';

  return (
    <div style={s.page}>
      <div style={s.header}>
        <h1 style={s.h1}>Gestor Web — CMS {label ? `· ${label}` : ''}</h1>
        <p style={s.sub}>Administra el contenido de tu sitio web público desde aquí.</p>
      </div>
      <TabContent />
    </div>
  );
}
